export default function getCopyright() {
  const currentYear = new Date().getFullYear();
  return `Copyright © ${currentYear} Goethe-Institut - All Rights Reserved`;
}